import Vue from 'vue';
import Vuex from 'vuex';

/* Plugins */
import vuexLocalStorage from './plugins/acvStorage';
import vuexUserStorage from './plugins/userStorage';

/* Modules */
import auctions from './modules/auctions/auctions.module';
import acvApiConstants from './modules/acvApiConstants.module';
import announcements from './modules/announcements.module';
import arbitration from './modules/arbitration.module';
import authorization from './modules/authorization.module';
import bidding from './modules/bidding.module';
import dealershipAddress from './modules/dealershipAddress.module';
import devFlags from './modules/devFlags.module';
import devTools from './modules/dev-tools/devTools.module';
import featureFlags from './modules/featureFlags.module';
import filters from './modules/filters.module';
import funNotifications from './modules/funNotifications.module';
import messaging from './modules/messaging.module';
import myAcvInvoices from './modules/myAcvInvoices.module';
import myAcvTitles from './modules/myAcvTitles.module';
import myInventory from './modules/myInventory.module';
import network from './modules/network/network.module';
import notifications from './modules/notifications.module';
import offboarding from './modules/offboarding.module';
import tours from './modules/tours.module';
import uiSettings from './modules/uiSettings.module';
import mobileTopBar from './modules/mobileTopBar.module';
import marketplaceAuctions from './modules/marketplace-auctions/marketplace-auctions.module';
import marketplaceRouter from './modules/marketplace/marketplaceRouter.module';
import marketplaceView from './modules/marketplace/marketplaceView.module';
import capital from './modules/capital.module';
import capitalRouting from './modules/capitalRouting.module';
import auctionCommonModals from './modules/auctions/auctionCommonModals.module';
import firebase from './modules/firebase.module';
import transportation from './modules/transportation/transportation.module';
import myAcvAuctions from './modules/auctions/MyAcv/myacv.auction.module';
import crossLanePromotionSettings from './modules/crossLanePromotionSettings.module';
import laneSortingFilterSettings from './modules/laneSortingFilterSettings.module';
import termsOfService from './modules/termsOfService.module';
import analytics from './modules/analytics.module';
import rewards from './modules/rewards.module';
import auctionAccess from './modules/auctionAccess.module';
/* Messaging */
import handleMessage from '../messaging/handleMessage';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin, vuexUserStorage.plugin],
  modules: {
    acvApiConstants,
    announcements,
    arbitration,
    auctions,
    authorization,
    bidding,
    capital,
    capitalRouting,
    dealershipAddress,
    devFlags,
    devTools,
    featureFlags,
    filters,
    firebase,
    funNotifications,
    marketplaceAuctions,
    marketplaceRouter,
    marketplaceView,
    messaging,
    myAcvInvoices,
    myAcvTitles,
    myInventory,
    network,
    notifications,
    offboarding,
    tours,
    uiSettings,
    auctionCommonModals,
    transportation,
    myAcvAuctions,
    crossLanePromotionSettings,
    laneSortingFilterSettings,
    termsOfService,
    mobileTopBar,
    analytics,
    rewards,
    auctionAccess,
  },
});
handleMessage(store);

export default store;
